export default __webpack_public_path__ + "static/media/dll-icon.ea4bcb74.svg";